import { render, staticRenderFns } from "./WorksMian.vue?vue&type=template&id=899f0620&scoped=true"
import script from "./WorksMian.vue?vue&type=script&lang=js"
export * from "./WorksMian.vue?vue&type=script&lang=js"
import style0 from "./WorksMian.vue?vue&type=style&index=0&id=899f0620&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "899f0620",
  null
  
)

export default component.exports